<template>
  <div>
    <table class="housing__details-table2">
      <thead>
        <tr>
          <td style="background-color:#dedede">Parameters</td>
          <td style="background-color:#dedede" v-for="(item, i) in step2.houseTypeArrObj" :key="item.type">{{ item.type }}</td>
        </tr>
        <tr>
          <td style="background-color:#dedede">Housing type</td>
          <td style="background-color: #c4def5" v-for="(item, i) in step2.houseTypeArrObj" :key="item.type">{{ item.selected_category }}</td>
        </tr>
        <tr>
          <td style="background-color:#dedede">Carpet area of dwelling <span class="highlight_units">(sq. M)</span></td>
          <td style="background-color: #c4def5" v-for="(item, i) in step2.houseTypeArrObj" :key="item.type">{{ item.carpet_area }}</td>
        </tr>
        <tr>
          <td style="background-color:#dedede">% Area of walls</td>
          <td style="background-color: #c4def5" v-for="(item, i) in step2.houseTypeArrObj" :key="item.type">{{ item.area_of_walls }}</td>
        </tr>
        <tr>
          <td style="background-color:#dedede">Built up area of dwelling<span class="highlight_units">(sq. M per DU)</span></td>
          <td style="background-color: #c4def5" v-for="(item, i) in step2.houseTypeArrObj" :key="item.type">{{ item.built_up_area }}</td>
        </tr>
        <tr>
          <td style="background-color:#dedede">No. of dwelling units<span class="highlight_units"> (DU)</span></td>
          <td style="background-color: #c4def5" v-for="(item, i) in step2.houseTypeArrObj" :key="item.type">{{ item.no_of_du }}</td>
        </tr>
      </thead>
    </table>
    <div style="display:flex">
      <!-- Common fields Table -->
      <table class="housing__details-table2">
        <tr>
          <td style="background-color:#dedede">Loading factor (%)</td>
          <td style="background-color:#dedede">No. of floors</td>
          <td style="background-color:#dedede">Floor Height <span class="highlight_units">(m)</span></td>
          <td style="background-color:#dedede">Area floor plate<span class="highlight_units">(sq. M)</span></td>
        </tr>
        <tr>
          <td>{{ step2.commonFields.loading_factor }}</td>
          <td>{{ step2.commonFields.no_of_floors }}</td>
          <td>{{ step2.commonFields.floor_height }}</td>
          <td style="background-color: #c8f0e0">{{ step2.summary_step2.area_floor_plate }}</td>
        </tr>
      </table>

      <!-- Final calcs table -->
      <table class="housing__details-table2">
        <tr>
          <td style="background-color:#dedede">Total Built-up Area<span class="highlight_units">(sq.M)</span></td>
          <td style="background-color:#dedede">Wall Cross-section area<span class="highlight_units">(sq.M)</span></td>
          <td style="background-color:#dedede">Surface area Wall<span class="highlight_units">(sq.M)</span></td>
        </tr>
        <tr>
          <td style="background-color: #c8f0e0">{{ step2.summary_step2.total_built_up_area }}</td>
          <td style="background-color: #c8f0e0">{{ step2.summary_step2.wall_cross_sectional_area }}</td>
          <td style="background-color: #c8f0e0">{{ step2.summary_step2.surface_area_wall }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    step2: {
      get: function() {
        return this.$store.state.schema.inputs.step2;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep2', step2);
      },
    },
  },
};
</script>

<style lang="scss">
.housing__details-table2 {
  padding: 12px;
  width: 100%;
  // border: 1px solid #a4abb3;
  border-spacing: 0px;
  .table-heading-housing2 {
    background-color: #c4def5;
    padding: 4px;
    font-size: 20px;
    background-color: #c8f0e0;
    color: #2cb17c;
  }
  td {
    border: 1px solid #a4abb3;
    border-spacing: 0px;
    padding: 2px;
    text-align: center;
    font-size: 12px;
  }
}
.highlight_units {
  font-size: 10px;
  opacity: 0.6;
}
</style>
